import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from 'store';
import { CauseType, CharityType } from 'store/causes/types';
import { BonoBotStoreType, ChatMessageType, MessageActionStatusType } from './types';

const initialState: BonoBotStoreType = {
   chatInput: '',
   messages: [],
   storedThreadId: null,
   causesList: [],
   charitiesList: [],
   // suggested state
   suggestedByBotCauses: [],
   suggestedByBotCharities: [],
   status: null,
   // selected state
   selectedCauses: [],
   selectedCharities: [],
   donationAmount: 0,
};

export const bonoBotSlice = createSlice({
   name: 'bonoBot',
   initialState,
   reducers: {
      setConversationStatus(state, action: PayloadAction<MessageActionStatusType>) {
         return { ...state, status: action.payload };
      },
      setChatInput(state, action: PayloadAction<string>) {
         return { ...state, chatInput: action.payload };
      },
      setDonationAmount(state, action: PayloadAction<number>) {
         return { ...state, donationAmount: action.payload };
      },
      setSuggestedByBotCauses(state, action: PayloadAction<CauseType[]>) {
         return { ...state, suggestedByBotCauses: action.payload };
      },
      setSuggestedByBotCharities(state, action: PayloadAction<CharityType[]>) {
         return { ...state, suggestedByBotCharities: action.payload };
      },
      setCausesList(state, action: PayloadAction<CauseType[]>) {
         return { ...state, causesList: action.payload };
      },
      setCharitiesList(state, action: PayloadAction<CharityType[]>) {
         return { ...state, charitiesList: action.payload };
      },
      setSelectedCauses(state, action: PayloadAction<CauseType[]>) {
         return { ...state, selectedCauses: action.payload };
      },
      setSelectedCharities(state, action: PayloadAction<CharityType[]>) {
         return { ...state, selectedCharities: action.payload };
      },
      setThreadId(state, action: PayloadAction<string>) {
         return { ...state, storedThreadId: action.payload };
      },
      addMessage(state, action: PayloadAction<ChatMessageType>) {
         const newMessages = [...state.messages];
         newMessages.push(action.payload);
         return { ...state, messages: newMessages };
      },
      clearStore() {
         return initialState;
      },
   },
});

export const {
   setConversationStatus,
   setChatInput,
   setSuggestedByBotCauses,
   setSuggestedByBotCharities,
   setCausesList,
   setCharitiesList,
   addMessage,
   setThreadId,
   clearStore,
   setDonationAmount,
   setSelectedCauses,
   setSelectedCharities,
} = bonoBotSlice.actions;

export const bonoBotState = (state: RootState) => state.bonoBot;
